// useNow — a ticking clock for live relative-time labels.
//
// Re-renders the caller every `intervalMs` and returns the current epoch ms, so
// relative "time ago" labels (formatRelativeTime) advance on their own without a
// data re-fetch — the grid's polling keeps the underlying timestamps fresh, this
// keeps their *display* fresh between polls (and even if a poll fails). Pauses
// while the tab is hidden (nothing to update off-screen) and re-syncs on return.

import { useEffect, useState } from 'react';

export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === 'visible') setNow(Date.now());
    };
    const id = window.setInterval(tick, intervalMs);
    document.addEventListener('visibilitychange', tick);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [intervalMs]);
  return now;
}
